<template>
    <div class="connect">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Contect"></navbar>
        <section class="mogos">
            <div class="mogos-wrap">
                <div class="cart">
                    <img  src="../../assets/connect/mogos@2x.png" >
                </div>
                <div class="cart-content">
                    <h1 class="font-big">MOGO S</h1>
                    <p class="font-mid">{{$t('connect_content1')}}</p>
                </div>
                <div class="connect_btn">
                    <router-link  :to="{path:'/product/mogos',query:{id:1}}">
                        <button class="font-small"> {{$t('home_mogos_get')}}</button>
                    </router-link>
                </div>
            </div>
        </section>
        <div style="clear: both"></div>
        <section class="iglobal">
            <div class="iglobal-wrap">
                <div class="cart">
                    <img  src="../../assets/connect/iGlobal@2x.png" >
                </div>
                <div class="cart-content">
                    <h1 class="font-big">iGlobal</h1>
                    <p class="font-mid">{{$t('connect_content2')}}</p>
                </div>
                <div class="connect_btn">
                    <router-link :to="{path: '/product/iglobal/?id=9'}">
                        <button class="font-small">{{$t('connect_more')}}</button>
                    </router-link>
                </div>
            </div>
        </section>
        <div style="clear: both"></div>
        <section class="iapp">
            <div class="iapp-wrap">
                <h1 class="font-big">iAPP</h1>
                <p class="font-mid">{{$t('connect_content3')}}</p>
                <div class="connect_btn">
                    <router-link :to="{name: 'app'}">
                        <button class="font-small">{{$t('connect_download')}}</button>
                    </router-link>
                </div>
                <div class="iapp-img">
                    <img src="../../assets/connect/iapp_en@2x.png">
                </div>
            </div>
        </section>
        <div style="clear: both"></div>
        <section class="ivoice">
            <div class="ivoice-wrap">
                <h1 class="font-big">iVoice</h1>
                <p class="font-mid">{{$t('connect_content4')}}</p>
                <div class="connect_btn">
                    <router-link :to="{name: 'iVoice'}">
                        <button class="font-small">{{$t('connect_more')}}</button>
                    </router-link>
                </div>
                <div class="ivoice-img">
                    <img src="../../assets/home/new_home/ivoice_global.png">
                </div>
            </div>
        </section>
        <div style="clear: both"></div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'
    export default {
         data () {
             return {
                 isTransparent:false
             }
         },
         components:{
             navbar
         }
    }
</script>

<style lang="scss" scpoed>
    @import "../../scss/_connect.scss";
</style>



// WEBPACK FOOTER //
// Connect.vue?15cb1506